import { jsxs, jsx } from "react/jsx-runtime";
import React__default from "react";
import { useExperiments } from "../../../contexts/experiments-context.js";
import { getHeaderVariantCustomStylesWUT, getHeaderAndParagraphCustomStylesWUT, useRicosTheme } from "../../../theme/ricos-theme-utils.js";
import RicosViewer from "../../../ui/ricos-viewer/ricos-viewer.js";
import { ToggleTruncateButtonWUT } from "../../../ui/ricos-viewer/toggle-truncate-button-wut.js";
import { useTruncateRicosContent } from "../../../ui/ricos-viewer/use-truncate-ricos-content.js";
import { EXPERIMENTS } from "../../../constants/experiments.js";
const HeaderWUT = ({
  content,
  maxShownParagraphs,
  id,
  FieldLayout
}) => {
  const { isExperimentEnabled } = useExperiments();
  const isHeadingLevelsEnabled = isExperimentEnabled(
    EXPERIMENTS.ENABLE_HEADING_LEVELS
  );
  const customStyles = React__default.useMemo(
    () => isHeadingLevelsEnabled ? {
      ...getHeaderAndParagraphCustomStylesWUT(),
      ...getHeaderVariantCustomStylesWUT()
    } : getHeaderAndParagraphCustomStylesWUT(),
    [isHeadingLevelsEnabled]
  );
  const customTheme = useRicosTheme({ customStyles });
  const {
    displayedContent,
    isTruncated,
    isTruncateButtonShown,
    toggleTruncate
  } = useTruncateRicosContent(content, maxShownParagraphs);
  return /* @__PURE__ */ jsxs(FieldLayout, { fieldId: id, children: [
    /* @__PURE__ */ jsx(RicosViewer, { content: displayedContent, customTheme }),
    isTruncateButtonShown && /* @__PURE__ */ jsx(
      ToggleTruncateButtonWUT,
      {
        isTruncated,
        onClick: toggleTruncate
      }
    )
  ] });
};
export {
  HeaderWUT
};
//# sourceMappingURL=header-wut.js.map
